module.exports = __webpack_public_path__ + "img/ubc_logo_small.81028f97.png";